define([
    "./monitoringYardControlModule",
    "./monitoringYardControlRouter",
    "text!./monitoringYardControl.html"
], function () {
});